'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvLibraryMusic = function AvLibraryMusic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z' })
  );
};
AvLibraryMusic = (0, _pure2.default)(AvLibraryMusic);
AvLibraryMusic.displayName = 'AvLibraryMusic';
AvLibraryMusic.muiName = 'SvgIcon';

exports.default = AvLibraryMusic;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/library-music.js
 ** module id = 1669
 ** module chunks = 0
 **/